import {Injectable} from '@angular/core';

import {map, Observable, tap} from 'rxjs';
import {WebAccessService} from '../web.access/web-access.service';
import {DriverScoringGroup} from '../../models/domain/DriverScoringGroup';

@Injectable()
export class DriverService {

  constructor(
    private $webAccess: WebAccessService
  ) {
  }

  getDriverScoringForPeriod(driverId: number): Observable<DriverScoringGroup[]> {
    return new Observable(observer => {
      this.$webAccess.GetEcoDrivingList(driverId).pipe(
        map(response => <any[]>response.Result),
        tap(response => {
          for (const resp of response) {
            resp.Stats = resp.St;
          }
        }),
        map(response => <DriverScoringGroup[]>response))
        .subscribe(response => {
          observer.next(response);
          observer.complete();
        });
    });
  }
}
